<template>
  <div>
    <div v-for="(item,index) in approvalList" :key="index">
      <countersign
        v-if="item.jointlyApprovalList.length>0"
        :isLastElement="approvalList.length-1==index"
        :approvalInfo="item"
      ></countersign>
      <process
        v-else-if="item.approveStatus!=null||index==0"
        :approvalInfo="item"
        :currentApplyEmployee="applyEmployeeID"
        :isLastElement="approvalList.length-1==index"
        :currentStep="currentStep"
      ></process>

      <comment v-else :isLastElement="approvalList.length-1==index" :approvalInfo="item"></comment>
    </div>
  </div>
</template>
<script>
import process from "./approvalProcess";
import countersign from "./approvalCountersign";
import comment from "./approvalComment";
import * as dd from "dingtalk-jsapi";
import { mapState } from "vuex";
export default {
  props: {
    approvalList: {
      type: Array,
      default() {
        return [];
      }
    },
    applyEmployeeID: {
      default: ""
    },
    currentStep: {
      default: 0
    }
  },
  computed: {
    ...mapState({
      dingdingconfig: state => state.dingdingconfig
    })
  },
  methods: {
    openProfile(dingdingUserId) {
      if (dingdingUserId.length > 0) {
        let _this = this;
        dd.biz.util.open({
          name: "profile", //页面名称
          params: { id: dingdingUserId, corpId: _this.dingdingconfig.corpId }, //传参
          onSuccess: function() {
            /**/
          },
          onFail: function(err) {}
        });
      }
    }
  },
  components: {
    process,
    countersign,
    comment
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalProcess/index.vue